import { BaseWebComponentDataProviderFactory } from '../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ } from '../../../webcomponents.constants';
import { EasmArtifactsInventoryGridViewDataProvider } from '../dataProvider/EasmArtifactsInventoryViewDataProvider';

export class EasmArtifactsInventoryDataProviderFactory extends BaseWebComponentDataProviderFactory {
  public constructor() {
    super();

    this.map.set(API_TYPE_GZ, EasmArtifactsInventoryGridViewDataProvider);
  }
}
